export default "__VITE_ASSET__BzMrWzNH__"